import { Grid } from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'

import ImageWithStatusBadge from '../ImageWithStatusBadge'

interface ImageGridProps {
  showIdCode?: boolean,
  specifiedImageIds: number[],
}

const ImageGrid = (props: ImageGridProps) => {
  const { specifiedImageIds, showIdCode } = props

  const images = useSelector(reduxState => reduxState.entities.images)

  return (
    <Grid
      // @ts-expect-error TS2322
      gridGap="medium"
      gridAutoRows="1fr"
      gridTemplateColumns="repeat(auto-fill, minmax(180px, 1fr))"
      gridTemplateRows="repeat(auto-fill, minmax(140px, 1fr))"
      padding="large"
    >
      {specifiedImageIds.map((imageId: number) => {
        const image = images[imageId] || {}

        return <ImageWithStatusBadge image={image} showIdCode={showIdCode} />
      })}
    </Grid>
  )
}

export default ImageGrid
